import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import Helmet from 'react-helmet';

import { Table } from '../components/CommonTable';
import { DragSourceAndDropTarget } from '../components/DnDWrapper';
import { FormDropDownSingleSelect } from './../components/CommonFormComponents';
import ManagerButton from '../components/button/ManagerButton';
import Information from '../components/modals/common/Information';
import { MasterPageHeader } from '../components/PageHeader';
import CompanyService from '../services/Companies';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import fetchMg from '../utilities/fetchManager';
import { createLocalEventManager } from '../utilities/EventManager';
import { getSortButton } from '../utilities/sortUtility';
import Auth from '../components/Auth';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';
import {
  HEADER_CONSTANTS,
  APPROVAL_STATUS,
  REQUEST_PARAMS,
  ENTER_STATUS,
  CONTRACT_FLAG,
  PAGE_REFERER,
  LIST_SERVICES,
  USER_ROLES,
} from '../utilities/constants';
import { isTargetRoleId } from '../utilities/roleUtility';
moment.locale('ja');

const MY_EVENT = {
  SEARCH_FORM_CHANGE: 'search_form_change', // params変更イベント
};
const EventMg = createLocalEventManager(MY_EVENT); // localのEventMgを作成
const SEARCH_COMPONENT_BRANCH_LABEL = '支店名を選択'; // 支店コンポーネントラベル名

/**
 * @description 新規現場承認画面
 */
export class FieldRequestList extends React.Component {
  constructor(props) {
    super(props);

    const params = {
      offset: 0,
      limit: REQUEST_PARAMS.parentLimit,
      approval_flag: APPROVAL_STATUS.unapproved.id,
    };

    this.state = {
      params, // 検索条件
      tempParams: params, // 検索条件(保管用)
      search_form_open: false, // search_form の開閉
      contractFlag: SessionStorageService.getContractFlag(), // 契約フラグ
      visibleDialogFlag: false, // 開閉用ダイアログフラグ
      isFetch: false, // 再読み込みフラグ
      isLoading: true, // ロード中フラグ
      isNewSearch: false, // 検索ボタン押下時のフラグ(BLDE_V2-41384)
      searchParams: {
        clearFlag: false,
      },
      listUsingServices: LIST_SERVICES,
    };

    this.total = 0; // 検索結果件数を保持
    this.roleId = LocalStorageService.getRoleId(); // ロールID
    this.handleVisibleDialog = this.handleVisibleDialog.bind(this); // ダイアログ開閉設定
    this.contractCheck = this.contractCheck.bind(this); // 契約有無チェック
    this.searchExecution = this.searchExecution.bind(this); // 検索実行
    this.searchButtonRef = React.createRef(); // 検索ボタン要素
    this.company_id = SessionStorageService.getCompanyId();

    this.callbacks = [
      {
        type: MY_EVENT.SEARCH_FORM_CHANGE, // 検索フォームの変更イベント
        callback: (val, key, isFetch) => {
          const params = { ...this.state.params };
          if (!_.has(params, key)) {
            params.offset = 'new';
          }
          params[key] = val;

          if (isFetch) {
            this.setState({ params, isFetch });
          } else {
            const tempParams = { ...this.state.tempParams };
            tempParams[key] = val;
            this.setState({ tempParams, isFetch });
          }
        },
      },
    ];

    // イベントにコールバックを設定
    _.each(this.callbacks, val =>
      EventMg.addEventListener(val.type, val.callback)
    );
  }

  componentDidMount() {
    this.getInfoCompany();
  }

  componentDidUpdate() {
    if (this.state.searchParams.clearFlag === true) {
      this.setState({
        searchParams: {
          clearFlag: false,
        },
      });
    }
  }

  componentWillUnmount() {
    // 追加したイベントを削除
    _.each(this.callbacks, val => {
      EventMg.removeEventListener(val.type, val.callback);
    });
  }

  /**
   * @description table itemのデータを追加ロードする
   * @param {Array|Any} list_data 取得したデータ一覧
   */
  async fieldItemLoad(list_data) {
    const params = _.clone(this.state.params);
    const deleteServiceFlag = flg => {
      if (_.isEqual(Number(params[flg]), ENTER_STATUS.out.id)) {
        delete params[flg];
      }
    };

    _.forEach(LIST_SERVICES, service => {
      deleteServiceFlag(`${service.FLAG}`);
    });

    if (params.offset === 'new') {
      params.offset = 0;
    } else if (_.isArray(list_data)) {
      params.offset = list_data.length;
    }

    // ソート用パラメータ params.order が
    // branch_asc か branch_desc の場合
    // パラメータを切り替える
    delete params.sort_branch_name;
    switch (params.order) {
      case 'branch_asc':
        params.sort_branch_name = 'asc';
        delete params.order;
        break;
      case 'branch_desc':
        params.sort_branch_name = 'desc';
        delete params.order;
        break;
    }

    const data = await fetchMg
      .GetAjax(`/api/private/fields/applied_lists`, params)
      .catch(() => ({ result: false }));

    if (data.result) {
      this.total = data.data.total; // 検索結果件数を取得

      // ソート用パラメータに sort_branch_name を使用する場合には
      // params.order = branch_asc か branch_desc に修正する
      if (_.has(params, 'sort_branch_name')) {
        params.order = `branch_${params.sort_branch_name}`;
        delete params.sort_branch_name;
      }
      this.searchButtonRef.current.disabled = false;
      this.setState({
        params,
        isFetch: false,
        isLoading: false,
        isNewSearch: false,
      });
      return data.data.entities.fields || [];
    }

    this.searchButtonRef.current.disabled = false;
    return [];
  }

  /**
   * @description 検索実行
   */
  searchExecution() {
    this.searchButtonRef.current.disabled = true;

    const tempParams = { ...this.state.tempParams };
    delete tempParams.order;
    tempParams.offset = 0;
    const params = { ...this.state.params, ...tempParams };

    this.setState({
      params,
      tempParams,
      isFetch: true,
      isLoading: true,
      isNewSearch: true,
    });
  }

  /**
   * @description 契約有無チェック
   * @param {boolean} isEdit true: 現場詳細, false: 新規現場登録
   * @param {number} fieldId 現場ID
   */
  contractCheck(isEdit, fieldId = null) {
    if (
      this.state.contractFlag === CONTRACT_FLAG.yesContract.id ||
      isTargetRoleId([USER_ROLES.prime], this.roleId)
    ) {
      if (isEdit) {
        const pageParams = {
          id: fieldId,
          pageReferer: PAGE_REFERER.fieldRequestList.key,
        };
        _masterSlideLoader.show('FieldsDetail', { state: pageParams });
      } else {
        _masterSlideLoader.show('FieldRegister', { state: {} });
      }
    } else {
      this.handleVisibleDialog(true);
    }
  }

  /**
   * @description ダイアログ開閉設定
   * @param {string} visibleDialogFlag ダイアログフラグ
   */
  handleVisibleDialog(visibleDialogFlag) {
    this.setState({ visibleDialogFlag });
  }

  getInfoCompany = async () => {
    const listUsingServices = _.cloneDeep(this.state.listUsingServices);
    const { result, data } = await CompanyService.show(this.company_id);
    if (result) {
      const available_progress_flg = _.get(
        data,
        'entities.company.available_progress_flg'
      );
      if (!available_progress_flg) {
        delete listUsingServices.PROGRESS;
      }
      this.setState({ listUsingServices });
    }
  };

  render() {
    let {
      params,
      search_form_open,
      visibleDialogFlag,
      isFetch,
      isLoading,
      isNewSearch,
      listUsingServices,
    } = this.state;

    return (
      <div className='master-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 新規現場申請承認</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <TitleHeader />
          <div id='infinityscroll-target' className='master-slide-view__table'>
            <HeaderMenu onContractCheck={this.contractCheck} />
            <SearchForm
              param={params}
              onOpen={() =>
                this.setState({
                  search_form_open: !search_form_open,
                })
              }
              onSearchExecution={this.searchExecution}
              searchButtonRef={this.searchButtonRef}
              isOpen={search_form_open}
              total={this.total}
              searchParams={this.state.searchParams}
              listUsingServices={listUsingServices}
              clearParams={() => {
                _.each(
                  document.querySelectorAll('.search-form__body input'),
                  input => {
                    input.value = null;
                    input.checked = null;
                  }
                );

                const params = {
                  offset: 0,
                  limit: REQUEST_PARAMS.parentLimit,
                  approval_flag: APPROVAL_STATUS.unapproved.id,
                };
                this.setState({
                  params,
                  tempParams: params,
                  isFetch: true,
                  isLoading: true,
                  isNewSearch: true,
                  searchParams: {
                    clearFlag: true,
                    name: '',
                  },
                });
              }}
            />

            <div className='master-slide-view__body'>
              <div className='constructionlist__list'>
                <Table
                  parentId='infinityscroll-target'
                  onLoad={this.fieldItemLoad.bind(this)}
                  // eslint-disable-next-line no-unused-vars
                  header={props => (
                    <TableHeader order={_.defaultTo(params.order, '')} />
                  )}
                  body={props => (
                    <TableItem
                      {...props}
                      onContractCheck={this.contractCheck}
                    />
                  )}
                  isFetch={isFetch}
                  isLoading={isLoading}
                  isNewSearch={isNewSearch}
                />
              </div>
            </div>
          </div>
        </div>
        <Information
          visible={visibleDialogFlag}
          message={messageUtility.getMessage('E-000-037')}
          buttonText={messageUtility.getMessage('I-000-011')}
          onClose={() => this.handleVisibleDialog(false)}
          buttonClassName='btn--sm--sub'
        />
      </div>
    );
  }
}

/**
 * @description ヘッダーのソート関数
 * @param {String} key ソートするKey名
 * @param {String} order 前回のソート内容
 */
const onSort = (key, order) => {
  EventMg.trigger(
    MY_EVENT.SEARCH_FORM_CHANGE,
    order === `${key}_asc` ? `${key}_desc` : `${key}_asc`,
    'order',
    true
  );
};

/**
 * @description リスト一覧のヘッダー部分
 */
const TableHeader = ({ order }) => (
  <thead className='table__header'>
    <tr className='table__label'>
      <td className='value-table value-table--table__label'>
        <div
          className='value-table__label'
          onClick={() => onSort('branch', order)}
        >
          支店名
          {getSortButton(order, 'branch')}
        </div>
      </td>
      <td className='value-table value-table--table__label'>
        <div
          className='value-table__label'
          onClick={() => onSort('name', order)}
        >
          現場名
          {getSortButton(order, 'name')}
        </div>
      </td>
      <td className='value-table value-table--table__label'>
        <div
          className='value-table__label'
          onClick={() => onSort('address', order)}
        >
          住所
          {getSortButton(order, 'address')}
        </div>
      </td>
      <td className='value-table value-table--table__label'>
        <div
          className='value-table__label'
          onClick={() => onSort('groundbreaking_date', order)}
        >
          着工日
          {getSortButton(order, 'groundbreaking_date')}
        </div>
      </td>
      <td className='value-table value-table--table__label'>
        <div
          className='value-table__label'
          onClick={() => onSort('complete_schedule_date', order)}
        >
          竣工日
          {getSortButton(order, 'complete_schedule_date')}
        </div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>ステータス</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>利用中のサービス</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label' />
      </td>
    </tr>
  </thead>
);

/**
 * @description Table Item コンポーネント
 */
class TableItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      canDrag: true,
    };
  }

  /**
   * @description オプションのicon一覧を返す。
   * @param {Object} data
   */
  setOptionIcons(data) {
    let icons = [];

    // 調整会議
    if (data.use_chosei_flg) {
      icons.push(<div className='option-icon-chosei' />);
    } else {
      icons.push(<div className='option-icon-empty' />);
    }
    // 入退場
    if (data.use_gk_flg) {
      icons.push(<div className='option-icon-entrance' />);
    } else {
      icons.push(<div className='option-icon-empty' />);
    }
    // 労安
    if (data.use_roan_flg) {
      icons.push(<div className='option-icon-greenfile' />);
    } else {
      icons.push(<div className='option-icon-empty' />);
    }
    // 進捗・歩掛
    if (data.use_progress_flg) {
      icons.push(<div className='option-icon-progress' />);
    } else {
      icons.push(<div className='option-icon-empty' />);
    }
    // 車両管理
    if (data.use_tracker_flg) {
      icons.push(<div className='option-icon-tracker' />);
    } else {
      icons.push(<div className='option-icon-empty' />);
    }

    return _.map(icons, (icon, i) => (
      <span
        key={`value-table__content-no.${i}`}
        className='value-table__content'
      >
        {icon}
      </span>
    ));
  }

  setOptionStatus(data) {
    let tags = [];
    // 竣工
    if (
      moment(data.complete_schedule_date, 'YYYY/MM/DD').isBefore(
        moment().subtract(1, 'day')
      )
    ) {
      tags.push(<div className='status--short'>竣工</div>);
    } else {
      tags.push(<div className='option-icon-empty-date' />);
    }
    // 否認
    if (data.approval_flag === APPROVAL_STATUS.disapproval.id) {
      tags.push(<div className='status--short--caution'>否認</div>);
    }

    return _.map(tags, (tag, i) => (
      <span
        key={`value-table__content-no.${i}`}
        className='value-table__content'
      >
        {tag}
      </span>
    ));
  }

  onEndDrag(drop_result, props, monitor, component) {
    this.setState({ canDrag: false });
    if (this.props.onEndDrag) {
      return this.props.onEndDrag(drop_result, props, monitor, component);
    }
  }

  onDropped(dropProps, monitor, dropComponent) {
    if (this.props.onDropped) {
      return this.props.onDropped(dropProps, monitor, dropComponent);
    }
  }

  onBeginDrag(props, monitor, component) {
    if (this.props.onBeginDrag) {
      return this.props.onBeginDrag(props, monitor, component);
    }
  }

  /**
   * @description ドラッグ＆ドロップできるようにラップする
   * @param {React.ReactElement} elements
   */
  setWrapperDnd(elements) {
    if (this.props.canDrag) {
      return (
        <DragSourceAndDropTarget
          id={this.props.id}
          onDropped={this.onDropped.bind(this)}
          onBeginDrag={this.onBeginDrag.bind(this)}
          onEndDrag={this.onEndDrag.bind(this)}
          canDrag={this.state.canDrag}
        >
          {elements}
        </DragSourceAndDropTarget>
      );
    }

    return elements;
  }

  render() {
    const { data } = this.props;

    return this.setWrapperDnd(
      <tr className='table__item'>
        <td className='value-table construction-list-value-table__branch-name'>
          <span className='label'>支店名</span>
          <div className='value-table__txt--7'>
            {data.company.company_branch_name || ''}
          </div>
        </td>
        <td className='value-table construction-list-value-table__name'>
          <span className='label'>現場名</span>
          <div className='value-table__txt--10'>{data.name || ''}</div>
        </td>
        <td className='value-table construction-list-value-table__address'>
          <span className='label'>住所</span>
          <div className='value-table__txt--10'>{data.address || ''}</div>
        </td>
        <td className='value-table construction-list-value-table__date'>
          <span className='label'>着工日</span>
          <div className='value-table__date'>
            {data.groundbreaking_date
              ? moment(data.groundbreaking_date).format('YYYY/MM/DD')
              : ''}
          </div>
        </td>
        <td className='value-table construction-list-value-table__date'>
          <span className='label'>竣工日</span>
          <div className='value-table__date'>
            {data.complete_schedule_date
              ? moment(data.complete_schedule_date).format('YYYY/MM/DD')
              : ''}
          </div>
        </td>
        <td className='value-table construction-list-value-table__option'>
          <span className='label'>ステータス</span>
          <div className='value-table__normal'>
            {this.setOptionStatus(data)}
          </div>
        </td>
        <td className='value-table construction-list-value-table__option'>
          <span className='label'>利用中のサービス</span>
          <div className='value-table__normal value-table__normal--wide'>
            {this.setOptionIcons(data)}
          </div>
        </td>
        <td className='value-table construction-list-value-table__edit'>
          <div className='value-table__normal'>
            <button
              className='btn--sm--stay'
              onClick={e => {
                e.stopPropagation();
                this.props.onContractCheck(true, data.id);
              }}
            >
              編集
            </button>
          </div>
        </td>
      </tr>
    );
  }
}

const TitleHeader = () => (
  <MasterPageHeader
    title={
      <React.Fragment>
        <Auth approvedRoles={[USER_ROLES.prime, USER_ROLES.branch]}>
          <div>新規現場承認</div>
        </Auth>
        <Auth approvedRoles={[USER_ROLES.manager]}>
          <div>新規現場申請</div>
        </Auth>
      </React.Fragment>
    }
    onClose={() => _masterSlideLoader.close()}
  />
);

const HeaderMenu = props => (
  <div className='master-slide-view__menu'>
    <ul className='btn-menu space-between-btn'>
      <li className='btn-menu__item'>
        <ManagerButton
          label={'申請'}
          buttonClass={'btn'}
          onClick={() => props.onContractCheck(false)}
        />
      </li>
    </ul>
  </div>
);

const SearchFormHeader = ({ onOpen, isOpen, total, clearParams }) => (
  <div className='search-form__header'>
    <div className='search-form__title'>
      検索条件（検索結果
      <span className='bold'>{total}</span>
      件)
    </div>
    <button
      className={isOpen ? 'accordion__btn show' : 'accordion__btn'}
      onClick={onOpen}
    />
    <button className='btn-text--sm' onClick={clearParams}>
      検索条件クリア
    </button>
  </div>
);

const SearchFormRadio = ({ label, name, value }) => (
  <div className='element__item'>
    <label className='radio'>
      <input
        name={`radio-${name}`}
        type='radio'
        onChange={() =>
          EventMg.trigger(MY_EVENT.SEARCH_FORM_CHANGE, value, name, false)
        }
      />
      <i className='i-2x' />
      <span>{label}</span>
    </label>
  </div>
);

const SearchFormElement = ({ label, children, eleClass }) => (
  <div className='form-element'>
    <div className='form-element__label'>
      <span className='label'>{label}</span>
    </div>
    <div className={eleClass}>{children}</div>
  </div>
);

/**
 * @param {string} label ラベル名
 * @param {number} name ラジオボタン名
 * @param {number} value 定数
 */
const SearchFormServiceCheckbox = ({ name, label, value, param }) => (
  <div className='element__item'>
    <label
      htmlFor='checkbox'
      className='checkbox'
      key={`checkbox-${name}-${value}`}
      onClick={() => {
        if (_.isEqual(Number(param[name]), ENTER_STATUS.enter.id)) {
          EventMg.trigger(
            MY_EVENT.SEARCH_FORM_CHANGE,
            (param[name] = ENTER_STATUS.out.id),
            name,
            false
          );
        } else {
          EventMg.trigger(
            MY_EVENT.SEARCH_FORM_CHANGE,
            (param[name] = ENTER_STATUS.enter.id),
            name,
            false
          );
        }
      }}
    >
      <input
        name='checkbox'
        type='checkbox'
        checked={_.isEqual(param[name], ENTER_STATUS.enter.id)}
        readOnly
      />
      <i className='i-3x' />
      <span>{label}</span>
    </label>
  </div>
);

/**
 * @description 検索フォームの 支店名コンポーネント
 */
const Shiten = props => (
  <div className='form-element'>
    <div className='form-element__label'>
      <span className='label'>支店名</span>
    </div>
    <div className='form-element__element'>
      <FormDropDownSingleSelect
        label={SEARCH_COMPONENT_BRANCH_LABEL}
        placeholder='支店名を入力して検索'
        apiPath='/api/private/company_branches/list'
        entitiesKey='company_branches'
        cancelItemFlag={true}
        params={props.searchParams}
        callback={val => {
          EventMg.trigger(
            MY_EVENT.SEARCH_FORM_CHANGE,
            val.id,
            'company_branch_id',
            false
          );
        }}
      />
    </div>
  </div>
);

/**
 * @description 検索フォームの 現場名コンポーネント
 */
const Genba = props => (
  <div className='form-element'>
    <div className='form-element__label'>
      <span className='label'>現場名</span>
    </div>
    <div className='form-element__element --col-xs-12 --col-md-12 --col-lg-9 --col-xl-9'>
      <input
        type='text'
        placeholder='現場名'
        onBlur={e =>
          EventMg.trigger(
            MY_EVENT.SEARCH_FORM_CHANGE,
            e.target.value,
            'name',
            false
          )
        }
      />
    </div>
  </div>
);

/**
 * @description 検索フォーム コンポーネント
 */
const SearchForm = ({
  param,
  onOpen,
  onSearchExecution,
  searchButtonRef,
  isOpen,
  total,
  searchParams,
  clearParams,
  listUsingServices,
}) => (
  <div className='master-slide-view__searchform'>
    <div className='search-form'>
      <SearchFormHeader
        onOpen={onOpen}
        isOpen={isOpen}
        total={total}
        clearParams={clearParams}
      />
      <div
        id='search-form-accordion'
        className={isOpen ? 'accordion show' : 'accordion'}
      >
        <div className='search-form__body set-width-dropdown'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>
              <Shiten searchParams={searchParams} />
              <Genba />
              <SearchFormElement
                label='利用中のサービス'
                eleClass='form-element__list form-element__list--service'
              >
                <div>
                  {_.map(listUsingServices, ({ ID, NAME, FLAG }) => (
                    <SearchFormServiceCheckbox
                      name={FLAG}
                      label={NAME}
                      value={ID}
                      key={ID}
                      param={param}
                    />
                  ))}
                </div>
                <button
                  className='btn-fixedsize--stay search-form__btn'
                  data-qa='fields_field-search-btn'
                  onClick={onSearchExecution}
                  ref={searchButtonRef}
                >
                  検索
                </button>
              </SearchFormElement>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/FieldRequestList.jsx